let apiBase = {
  queryAppInfo: '/api/show/queryMemberContactList',
  queryMemberInfo: '/api/show/queryMemberContactList',
  submitLog: '/api/show/queryMemberContactList',
  device:'/device',
  addEventLog: '/mapi/collect/addEventLog',//数据收集
  addOpenExceptLog: '/mapi/collect/addOpenExceptLog', //异常事件日志
  queryDocDetail:'/mapi/show/queryDocDetail',
  getBrandByHW:'/getBrandByHW'
}
let singleHomeServerObject = null;
class HomeServer {
  constructor() {}
  //获取应用信息
  queryAppInfo(params = {}) {
    return $http({
        method: 'get',
        url: apiBase.queryAppInfo,
        params: params,
    })
  }
  //获取厂商信息
  queryMemberInfo(params = {}) {
    return $http({
        method: 'get',
        url: apiBase.queryMemberInfo,
        params: params,
    })
  }

  submitLog(params = {}) {
    return $http({
        method: 'get',
        url: apiBase.submitLog,
        params: params,
    })
  }

  device(params = {}) {
    return $http({
        method: 'get',
        url: apiBase.device,
        params: params,
    })
  }
  addOpenExceptLog(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.addOpenExceptLog,
      params: params,
    })
  }

  addEventLog(params = {}) {
    return $http({
        method: 'post',
        url: apiBase.addEventLog,
        params: params,
    })
  }
  queryDocDetail(params = {}) {
    return $http({
        method: 'post',
        url: apiBase.queryDocDetail,
        params: params,
    })
  }
  
  getBrandByHW(params = {}) {
    return $http({
        method: 'get',
        url: apiBase.getBrandByHW,
        params: params,
    })
  }
}
function singleHomeServer() {
  if (singleHomeServerObject === null) {
      singleHomeServerObject = new HomeServer()
  }
  return singleHomeServerObject
}
export default singleHomeServer()
